export enum HeaderType {
  REPORTS = 1,
  INCIDENTS = 2,
  MIXED = 3
}
